import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import RecommendedUtilityForm from '../containers/RecommendedUtilityFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class RecommendedUtilityEditScreen extends Component {
  scrollToTop = () => {
    Logger.log('debug', `RecommendedUtilityEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('recommended_utilities_route_edit')} />
            <RecommendedUtilityForm id={this.props.match.params.id} />
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default RecommendedUtilityEditScreen;

Logger.log('silly', `RecommendedUtilityEditScreen loaded.`);
